import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, CanActivateFn } from '@angular/router';

import * as fromRoot from '@core/redux/index';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';

// Интерфейсы для Telegram WebApp
interface TelegramInitDataUnsafe {
  start_param?: string;
}

interface TelegramWebApp {
  initDataUnsafe?: TelegramInitDataUnsafe;
}

declare global {
  interface Window {
    Telegram?: {
      WebApp?: TelegramWebApp;
    };
  }
}

// Функциональный guard для Angular 19
export const tgGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const router = inject(Router);
  const store = inject(Store<fromRoot.State>);

  const isAuth$ = store.select(fromRoot.getIsAuth);
  const authStep$ = store.select(fromRoot.getStep);

  return combineLatest([isAuth$, authStep$]).pipe(
    map(([isAuth, authStep]) => {
      if (!isAuth) {
        router.navigate(['/auth/sign-in']);
        return false;
      }

      if (authStep === 'end') {
        return handleTelegramRedirect(router);
      }

      return true;
    }),
    take(1)
  );
};

/**
 * Обрабатывает перенаправление на основе параметров Telegram WebApp
 */
function handleTelegramRedirect(router: Router): boolean {
  try {
    const tg = window.Telegram?.WebApp;

    if (!tg?.initDataUnsafe?.start_param) {
      return true;
    }

    const startParam = tg.initDataUnsafe.start_param;
    const routeParams = parseStartParam(startParam);

    if (routeParams) {
      console.log('Telegram redirect to task:', routeParams);
      router.navigate(['cabinet', routeParams.projectId, 'load', 'list'], { queryParams: { id: routeParams.taskId } });
      return false;
    }

    return true;
  } catch (error) {
    console.error('Ошибка при обработке данных Telegram:', error);
    return true;
  }
}

/**
 * Парсит start_param и извлекает projectId и taskId
 */
function parseStartParam(startParam: string): { projectId: string; taskId: string } | null {
  const match = startParam.match(/cabinet_([^_]+)_task_([^_]+)/);

  if (!match || match.length < 3) {
    return null;
  }

  return {
    projectId: match[1],
    taskId: match[2],
  };
}
